class PaymentsPlayerController {
	constructor(TeamsFactory, PaymentsFactory, PlayersFactory, $filter, ngDialog){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');
		let $date = $filter('date');

		vm.$onInit = () =>{
			vm.teams = [];
			vm.payments = [];
			TeamsFactory.getAll().then(response =>{
				vm.teams = response.data;
			});
			PaymentsFactory.getAll().then(response =>{
				vm.payments = response.data.filter(payment =>{
					return payment.required_player === 1 || payment.id === 24;
				});
			});
		};

		vm.gridOptions = {
			enableSorting: true,
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [
				{
					field: 'code',
					enableFiltering: false,
					name: $translate('CODE'),
					width: '110',
				}, {
					field: 'playerName',
					name: $translate('NAME'),
					enableFiltering: true,
				}, {
					field: 'actions',
					enableFiltering: false,
					name: $translate('ACTIONS'),
					headerCellClass: 'text-center',
					cellTemplate: '' +
					'<div ' +
					'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
					'<div class="buttons">' +
					'<button class="btn btn-sm btn-success" translate ' +
					'data-toggle="modal" ' +
					'data-target="#paymentPlayerModel" ' +
					'ng-click="grid.appScope.vm.openAddPaymentModel(row.entity)">ADD</button> ' +
					'<button class="btn btn-sm btn-info" translate ' +
					'ng-click="grid.appScope.vm.getReport(row.entity.player_id)">PDF</button> ' +
					'</div>' +
					'</div>',
					width: '340',
				},
			],
		};
		vm.dateConfig = { startView:'day', minView:'day',  dropdownSelector: '#dateDropdown' };

		vm.getReport = (playerId) => {
			const tabWindowId = window.open('about:blank', '_blank');
			PaymentsFactory.report(PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, playerId).then(response =>{
				let file = new Blob([response.data], {type: 'application/pdf'});
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};

		vm.reloadPlayers = () =>{
			if(!vm.activeTeam.team_id){ return ;}
			PlayersFactory.getAll({team_id: vm.activeTeam.team_id}).then(response =>{
				vm.players = response.data;
				vm.gridOptions.data = response.data;
			});
		};

		/* Modal */
		vm.openAddPaymentModel = (player) =>{
			vm.activePlayer = player;
			vm.playerPayment = {};
			vm.playerPayment.player_id = vm.activePlayer.player_id;
			vm.playerPayment.payment_at = new Date();
		};
		vm.addPayment = () =>{
			vm.playerPayment.payment_at = $date(vm.playerPayment.payment_at, "yyyy-MM-dd");
			PaymentsFactory.addPayment(PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, vm.playerPayment).then(response => {
				ngDialog.open({template: 'successTemplate'});
			});
		};
	}
}

export default PaymentsPlayerController;



// WEBPACK FOOTER //
// ./client/app/components/payments/paymentsPlayer/paymentsPlayer.controller.js